export const actionAddToShoppingCart = (data) => ({
    type: 'ACTION_ADD_TO_SHOPPING_CART', data
});

export const actionRemoveFromShoppingCart = (data) => ({
    type: 'ACTION_REMOVE_FROM_SHOPPING_CART', data
});

export const actionRemoveAllItemFromShoppingCart = () => ({
    type: 'ACTION_REMOVE_ALL_ITEM_IN_CART'
});
